"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
function FormChannel(_a) {
    var onChange = _a.onChange, value = _a.value, params = _a.params;
    var channels = ra_fetch_1.useApi('backend').index('channels', params)[0];
    if (channels.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    if (!channels.data.length) {
        return react_1.default.createElement(storybook_1.Texts.Primary, null, "Nog geen kanalen");
    }
    return react_1.default.createElement(storybook_1.Forms.Field, null,
        react_1.default.createElement(storybook_1.Forms.Label, null, "Kies een kanaal"),
        react_1.default.createElement(storybook_1.Forms.Select, { name: 'channel_id', value: value, onChange: function (channel_id) { return onChange(Number(channel_id)); } },
            react_1.default.createElement("option", { value: '' }, "Kies een kanaal"),
            channels.data.map(function (channel, index) { return react_1.default.createElement("option", { key: index, value: channel.id }, channel.label); })));
}
exports.default = FormChannel;
